import {each} from "lodash"

export default {
    name: "SetupChoiceUpdate",
    data: function () {
        return {
            selected: {},
        }
    },
    methods: {
        fillSelected() {
            let that = this;
            const selected = this.$store.getters["setup/choice"];
            each(this.selected, function (value, key) {
                that.selected[key] = selected[key];
            });

            if(this.defaults){
                each(this.defaults, function (defaultValue, key) {
                    if(that.selected[key] === null){
                        that.selected[key] = defaultValue;
                    }
                })
            }

        }
    },
    mounted() {
        this.fillSelected();
    },
    watch: {
        selected: {
            deep: true,
            immediate: true,
            handler: function (newValue) {
                const choice = this.$store.getters["setup/choice"];
                let filledEntries = Object.fromEntries(Object.entries(newValue).filter(value => value[1] !== null));
                let newChoice = {...choice, ...filledEntries};
                this.$store.commit('setup/setChoice', newChoice);
                if(this.$store.getters['auth/recommendationCode']){
                    this.$store.commit('auth/recommendationCode', null);
                }
            }
        }
    }
}
